import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';
import { Link } from 'react-router-dom';
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import CommentIcon from '@mui/icons-material/Comment';
import Box from '@material-ui/core/Box';
import utils from '../../utils';
import '../../styles/components/volunteers/volunteer-meta.scss';
import { Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

const useStyles = makeStyles({
  root: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
});

export default function VolunteerMeta(props) {
  const { item, id, fullName, education, profession, hobby, department, year } =
    props;
  const classes = useStyles();
  const hasComments = item?.serviceInfo?.comments?.length > 0;

  return (
    <div className="volunteer-meta">
      <Card className={classes.root} variant="outlined">
        <CardContent>
          {typeof item === 'object' ? (
            <div className="info">
              <Box>
                <Link to={`/volunteers/${id}`}>
                  <Typography variant="h5" component="h2">
                    {fullName || '—'}
                  </Typography>
                </Link>

                <Typography variant="body1" component="p">
                  <b>Образование:</b> {education || '—'}
                </Typography>

                <Typography variant="body1" component="p">
                  <b>Профессия:</b> {profession || '—'}
                </Typography>

                <Typography variant="body1" component="p">
                  <b>Хобби:</b> {hobby || '—'}
                </Typography>

                <Typography variant="body1" component="p">
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                    }}
                  >
                    <b>Возраст:</b>{' '}
                    <span
                      style={{
                        marginLeft: '4px',
                      }}
                    >
                      {utils.calculateAge(year) || '—'}
                    </span>
                    <Tooltip
                      placement="right-end"
                      fontSize="small"
                      title={
                        'Возраст рассчитывается на основе вычитания года ' +
                        'рождения из текущего года. Может быть погрешность ±1 год.'
                      }
                      style={{
                        marginLeft: '4px',
                      }}
                    >
                      <HelpOutlineIcon />
                    </Tooltip>
                  </div>
                </Typography>

                {department && (
                  <Typography
                    variant="body1"
                    component="p"
                    style={{
                      display: 'flex',
                      alignContent: 'center',
                      border: '1px solid lightgrey',
                      borderRadius: '5px',
                      padding: '7px 10px',
                      width: 'max-content',
                    }}
                  >
                    <AssignmentIndIcon color="primary" />
                    <b style={{ marginLeft: '5px' }}>{department}</b>
                  </Typography>
                )}
              </Box>

              {hasComments ? (
                <div className="comments">
                  <CommentIcon />
                  <Box ml={1}>{item?.serviceInfo?.comments?.length}</Box>
                </div>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <>
              <Typography variant="body1" component="p">
                <b>{item}</b>
              </Typography>
            </>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
